import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

/*
* LA CONSTANTE "root" DETERMINA EL ELEMENTO HTML EN DONDE SE VA A RENDERIZAR EL COMPONENTE "App"
* DICHO ELEMENTO HTML: "<div id="root"></div>"
*/

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <App />
  </>
);

reportWebVitals();
